export default function CategoriesIcon({ ...props }) {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" fill="currentColor" {...props}>
			<path d="M8 22.25V8h14.25v14.25ZM8 40V25.75h14.25V40Zm17.75-17.75V8H40v14.25Zm0 17.75V25.75H40V40ZM9.55 20.7H20.7V9.55H9.55Zm17.75 0h11.15V9.55H27.3Zm0 17.75h11.15V27.3H27.3Zm-17.75 0H20.7V27.3H9.55ZM27.3 20.7Zm0 6.6Zm-6.6 0Zm0-6.6Z" />
		</svg>
	)
}